export const PRIVACY_POLICY_SECTIONS = [
  {
    type: 'paragraph' as const,
    text: 'Настоящее Поручение на обработку персональных данных является неотъемлемой частью использования сайта на Платформе EDIPI (далее Платформа) и разработано в соответствии с Законом Республики Беларусь от 07.05.2021 N 99-З (ред. от 01.06.2022) "О защите персональных данных" (далее – Закон N 99-З) и иными НПА.',
  },
  {
    type: 'paragraph' as const,
    text: 'Если Вы не согласны с условиями Поручения, Вы не можете использовать Платформу.',
  },
  {
    type: 'paragraph' as const,
    text: 'Под акцептом в целях Поручения признается факт использования Платформы.',
  },
  {
    type: 'heading' as const,
    text: 'Термины и определения',
  },
  {
    type: 'paragraph' as const,
    text: 'Для целей настоящего Поручения применять термины в значении, указанном ниже:',
  },
  {
    type: 'paragraph' as const,
    text: '(1) Оператор — Администратор сайта на Платформе, Пользователь или лицо, уполномоченное Администратором сайта на Платформе и действующее от его имени, которое организует и осуществляет обработку персональных данных и определяет цели обработки и состав персональных данных, подлежащих обработке, а также действия (операции), совершаемые с персональными данными;',
  },
  {
    type: 'paragraph' as const,
    text: '(2) Обработчик — Общество с ограниченной ответственностью «ЭпикСофт» (УНП 193810135), адрес: 222108, г. Минск, ул. Казинца, д. 96, пом. 15(3 этаж);',
  },
  {
    type: 'paragraph' as const,
    text: '(3) Персональные данные (ПД) — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных), размещенная Оператором на сайте на Платформе, и которая позволяет его идентифицировать;',
  },
  {
    type: 'paragraph' as const,
    text: '(4) Контент пользователя — информация, в составе которой могут быть Персональные данные, размещенная/загруженная Оператором на сайте на Платформе при использовании функционала Платформы.',
  },
  {
    type: 'paragraph' as const,
    text: 'В Поручении могут быть использованы иные термины, выше не определенные, толкование которых будет производиться в соответствии с Договором.',
  },
  {
    type: 'heading' as const,
    text: '1. Предмет поручения',
  },
  {
    type: 'paragraph' as const,
    text: '1.1. Оператор поручает, а Обработчик принимает на себя обязательство осуществлять действия по хостингу Контента пользователя, который обрабатывается или будет обрабатываться Оператором.',
  },
  {
    type: 'paragraph' as const,
    text: '1.2. Основные положения',
  },
  {
    type: 'paragraph' as const,
    text: '1.2.1 Цель обработки Персональных данных — Хостинг сайта на серверах Обработчика.',
  },
  {
    type: 'paragraph' as const,
    text: '1.2.2 Перечень действий по обработке персональных данных в рамках Поручения: (1) накопление; (2) хранение; (3) передача (предоставление, доступ); (4) уничтожение/удаление Персональных данных.',
  },
  {
    type: 'paragraph' as const,
    text: 'Обработка осуществляется посредством размещения сайта Оператора на арендуемых мощностях в датацентрах на территории Республики Беларусь.',
  },
  {
    type: 'paragraph' as const,
    text: '1.2.3 Перечень Персональных данных — Определяется Оператором посредством использования Платформы и не контролируется Обработчиком.',
  },
  {
    type: 'paragraph' as const,
    text: '1.2.4 Способ выдачи Поручения — Использование функционала Платформы. Указанный способ выдачи Поручений является полной и окончательной инструкцией Оператора, выданными Обработчику.',
  },
  {
    type: 'paragraph' as const,
    text: '1.2.5 Срок действия Поручения — В течение всего срока использования Оператором Платформы, включая период блокировки Учетной записи Оператора.',
  },
  {
    type: 'heading' as const,
    text: '2. Заверения и гарантии Оператора',
  },
  {
    type: 'paragraph' as const,
    text: '2.1. Оператор заверяет и гарантирует, что: (1) получил Персональные данные законными способами; (2) обладает законными основаниями обработки Персональных данных (в том числе согласием субъектов Персональных данных на передачу Персональных данных Обработчику с целью хранения); (3) соблюдает принципы и правила обработки Персональных данных, предусмотренные законодательством Республики Беларусь.',
  },
  {
    type: 'paragraph' as const,
    text: '2.2. Оператор гарантирует, что любое лицо, осуществляющее обработку Персональных данных с использованием функционала Платформы, действует от имени Оператора и в соответствии с его инструкциями. При этом Оператор несет ответственность перед Обработчиком, если указанное лицо нарушает условия Поручения.',
  },
  {
    type: 'paragraph' as const,
    text: '2.3. Заверения и гарантии Оператора, указанные в п. 2.1 — 2.2. являются достоверными в любой момент времени/периода обработки Персональных данных в рамках Поручения.',
  },
  {
    type: 'paragraph' as const,
    text: '2.4. Оператор признает и осознает факт обработки Персональных данных при использовании функционала Платформы.',
  },
  {
    type: 'heading' as const,
    text: '3. Права, обязанности и ответственность Обработчика',
  },
  {
    type: 'paragraph' as const,
    text: '3.1. Обработчик обязуется соблюдать цель и ограничения обработки Персональных данных, определенных в Поручении.',
  },
  {
    type: 'paragraph' as const,
    text: '3.2. Обработчик обязуется исполнять Поручение самостоятельно, а также с привлечением третьих лиц, оставаясь ответственным перед Оператором за выполнение своих обязательств по Поручению.',
  },
  {
    type: 'paragraph' as const,
    text: '3.3. Обработчик обязан соблюдать конфиденциальность и обеспечить безопасность Персональных данных.',
  },
  {
    type: 'paragraph' as const,
    text: '3.4. Обработчик обязуется добросовестно сотрудничать с Оператором и оказывать ему разумное содействие при рассмотрении и урегулировании запросов (жалоб, требований), касающихся Поручения. В частности, Обработчик, получив такой запрос, обязан уведомить об этом Оператора в течение 3 (трех) рабочих дней с момента наступления указанного события путем направления соответствующего уведомления на электронный адрес Администратора сайта на Платформе.',
  },
  {
    type: 'paragraph' as const,
    text: '3.5. Обработчик несет ответственность перед Оператором за исполнение Поручения, в том числе за действия (бездействие) своих работников, получивших доступ к обрабатываемым по Поручению Оператора персональным данным, повлекшие разглашение таких Персональных данных, в пределах размера реального ущерба, подтвержденного документально, но в любом случае не более стоимости техподдержки сайта на Платформе за один месяц. В случае использования Оператором бесплатной тестовой версии сайта на Платформе, тестовый сайт предоставляется «как есть» и Обработчик не несет ответственности за нарушения/несоблюдение условий настоящего Поручения, а также за контент, размещенный Оператором на тестовом (бесплатном) сайте.',
  },
  {
    type: 'paragraph' as const,
    text: '3.6. Обработчик не контролирует и не несёт ответственность за контент, размещенный Оператором на сайте на Платформе.',
  },
  {
    type: 'heading' as const,
    text: '4. Права, обязанность и ответственность Оператора',
  },
  {
    type: 'paragraph' as const,
    text: '4.1. Оператор несет ответственность перед субъектом Персональных данных за действия, осуществляемые Обработчиком при исполнении Поручения.',
  },
  {
    type: 'paragraph' as const,
    text: '4.2. Оператор самостоятельно принимает решение и несет ответственность за определение того, подходит ли функционал Платформы для обработки Персональных данных согласно законодательству Республики Беларусь, а также за использование сайта на Платформе в соответствии с юридическими обязательствами Оператора.',
  },
  {
    type: 'paragraph' as const,
    text: '4.3. Оператор вправе не чаще одного раза в год запрашивать у Обработчика информацию, подтверждающие принятие мер и соблюдение в целях исполнения Поручения Оператора требований, установленных в Поручении.',
  },
  {
    type: 'paragraph' as const,
    text: '4.4. Оператор несет ответственность за безопасность выбранных им средств защиты доступа к сайту на платформе PIPS, а также самостоятельно обеспечивает их конфиденциальность.',
  },
  {
    type: 'paragraph' as const,
    text: '4.5. Оператор несет ответственность за все действия, а также их последствия, при использовании сайта на Платформе, при этом все действия, совершенные под Учетными записями Оператора, считаются произведенными самим Оператором.',
  },
  {
    type: 'paragraph' as const,
    text: '4.6. Оператор несет ответственность за реагирование на запросы со стороны субъектов Персональных данных, третьих лиц в отношении использования Оператором сайта на Платформе в целях обработки Персональных данных.',
  },
  {
    type: 'paragraph' as const,
    text: '4.7. Оператор несет ответственность за рассмотрение запросов субъектов Персональных данных, связанных с реализацией их прав, в том числе в случаях, когда использование Оператором функционала Платформы затрагивает права указанных лиц.',
  },
  {
    type: 'paragraph' as const,
    text: '4.8. Оператор обязуется предоставить Обработчику подтверждение наличия правовых оснований для обработки Персональных данных и факта надлежащего уведомления субъекта Персональных данных об их передачи, в течение 5 (пяти) календарных дней с момента получения соответствующего запроса от Обработчика.',
  },
  {
    type: 'paragraph' as const,
    text: '4.9. В случае предъявления Обработчику претензий и требований от третьих лиц, в том числе от субъектов Персональных данных и уполномоченных органов, в связи с исполнением Поручения, в том числе в случае предъявления претензии о неправомерности хостинга Обработчиком Персональных данных, размещенных Оператором на сайте на Платформе, Оператор обязан самостоятельно, своими силами и за свой счет урегулировать такие претензии, оградить Обработчика от возможных убытков и участия в рассмотрении претензий, требований и возможном судебном разбирательстве.',
  },
  {
    type: 'paragraph' as const,
    text: '4.10. В случае предъявления Обработчику исковых требований от третьих лиц, в том числе от субъектов Персональных данных и уполномоченных органов, в связи с исполнением Поручения, результатом которых станет судебный акт о взыскании средств с Обработчика, вступивший в законную силу, последний имеет право требовать от Оператора возмещения Обработчику понесенных им расходов в процессе урегулирования судебного спора и во исполнение судебного решения, а также все понесенные Обработчиком судебные расходы, убытки в полном объеме.',
  },
  {
    type: 'paragraph' as const,
    text: '4.11. Оператор несет риск невозможности использования сайта на Платформе PIPS, возникший вследствие исполнения Обработчиком обязанности по прекращению хостинга Персональных данных на основании Поручения Оператора.',
  },
  {
    type: 'heading' as const,
    text: '5. Конфиденциальность и безопасность',
  },
  {
    type: 'paragraph' as const,
    text: '5.1. Оператор обязуется установить требования к защите обрабатываемых персональных данных в соответствии со ст. 17 Закона N 99-З, при этом данное обязательство распространяется исключительно на Оператора и не должно трактоваться, как установление определенных Оператором Обработчику требований к защите обрабатываемых персональных данных.',
  },
  {
    type: 'paragraph' as const,
    text: '5.2. В соответствии с абзацем 4 п. 1. ст. 7 Закона N 99-З Обработчик принимает необходимые меры конфиденциальности и безопасности при исполнении Поручения с использованием средств автоматизации.',
  },
  {
    type: 'heading' as const,
    text: '6. Нарушение информационной безопасности',
  },
  {
    type: 'paragraph' as const,
    text: '6.1. Если Обработчику станет известно о каком-либо нарушении безопасности, которое ведет к случайной или незаконной передаче (предоставления, распространения, доступа) Персональных данных («Нарушение информационной безопасности»), Обработчик в течение 48 (сорока восьми) часов обязан: (1) уведомить Оператора о Нарушении информационной безопасности; (2) применить обоснованные меры для смягчения последствий и минимизации какого-либо ущерба, возникшего в результате Нарушения информационной безопасности.',
  },
  {
    type: 'paragraph' as const,
    text: '6.2. Обработчик предоставляет Оператору необходимую и достаточную информацию и поддержку, связанную с таким событием, которые могут понадобиться Оператору для выполнения его обязанностей в силу закона, а также для снижения негативных последствий, которые могут наступить в результате такого события.',
  },
  {
    type: 'paragraph' as const,
    text: '6.3. Обязательство Обработчика сообщать о таких Нарушениях информационной безопасности или реагировать на них в соответствии с данным разделом не является признанием со стороны Обработчика какой-либо вины или ответственности в связи с Нарушением информационной безопасности.',
  },
  {
    type: 'paragraph' as const,
    text: '6.4. Оператор принимает необходимые и достаточные меры, в том числе осуществляет контроль и управление доступом к Платформе, в целях недопущения Нарушения информационной безопасности при обработке Персональных данных с использованием сайта на Платформе. В случае Нарушения информационной безопасности в связи с действиями или бездействием Оператора, последний обязуется незамедлительно, но не позднее 48 (сорока восьми) часов с даты события, уведомить Обработчика, при этом с Обработчика снимается ответственность за безопасность и конфиденциальность данных, обрабатываемых в рамках Поручения.',
  },
  {
    type: 'heading' as const,
    text: '7. Применимое право и разрешение споров',
  },
  {
    type: 'paragraph' as const,
    text: '7.1. Настоящее Поручение регулируется и подлежит толкованию в соответствии с правом Республики Беларусь.',
  },
  {
    type: 'paragraph' as const,
    text: '7.2. Все споры, которые могут возникнуть между Сторонами в ходе исполнения Поручения, подлежат решению путем переговоров.',
  },
  {
    type: 'paragraph' as const,
    text: '7.3. В случае наличия противоречий между условиями настоящего Поручения и иными условиями использования сайта на Платформе в отношении обработки персональных данных, применяются условия настоящего Поручения.',
  },
  {
    type: 'paragraph' as const,
    text: '7.4. Обработчик оставляет за собой право вносить изменения и/или дополнения в условия Поручения в одностороннем порядке путем размещения измененного текста в сети Интернет https://www.edipi.by/. При каждом доступе и/или фактическом использовании сайта на Платформе, Оператор подтверждает свое согласие с условиями Поручения в редакции, действующей на момент фактического использования Программы.',
  },
]
